export default __webpack_public_path__ + "static/media/symphony_website.d5e48c1f.svg";